export const ACTION_IDS = {
	UNSET_PHONE: 'unsetPhone',
	UNSET_ACCOUNT_NUM: 'unsetAccount',
	UNSET_UPI_ID: 'unsetUpiId',
	BLOCK_USER: 'blockUser',
	UNBLOCK_USER: 'unblockUser',
	MARK_USER_FRAUD: 'markFraud',
	UNMARK_USER_FRAUD: 'unmarkFraud',
	BLOCK_UNBLOCK_DETAILS: 'blockUnblockDetails',
	USER_LEVEL_UPDATE: 'userLevelUpdate',
	GET_TDS_DATA: 'getTdsData',
	VIEW_DOB: 'viewDob',
	VIEW_PHONE: 'viewPhone',
	VIEW_ALTERNATE_PHONE: 'viewAlternatePhone',
	VIEW_EMAIL: 'viewEmail',
	UPDATE_ALTERNATE_PHONE: 'updateAlternatePhone',
	CANCEL_SUBSCRIPTION: 'cancelSubscription'
};

export const ACTION_LABELS = {
	[ACTION_IDS.UNSET_PHONE]: 'Unset',
	[ACTION_IDS.UNSET_ACCOUNT_NUM]: 'Unset',
	[ACTION_IDS.UNSET_UPI_ID]: 'Unset',
	[ACTION_IDS.BLOCK_USER]: 'Block',
	[ACTION_IDS.UNBLOCK_USER]: 'Unblock',
	[ACTION_IDS.MARK_USER_FRAUD]: 'Mark Fraud',
	[ACTION_IDS.UNMARK_USER_FRAUD]: 'Unmark Fraud',
	[ACTION_IDS.USER_LEVEL_UPDATE]: 'Update',
	[ACTION_IDS.VIEW_DOB]: 'View',
	[ACTION_IDS.VIEW_PHONE]: 'View',
	[ACTION_IDS.VIEW_ALTERNATE_PHONE]: 'View',
	[ACTION_IDS.VIEW_EMAIL]: 'View',
	[ACTION_IDS.UPDATE_ALTERNATE_PHONE]: 'Update',
	[ACTION_IDS.CANCEL_SUBSCRIPTION]: 'Cancel Subscription'
};

export const BUTTON_LABELS = {
	AGREE: 'Submit',
	DISAGREE: 'Cancel',
	VIEW: 'View'
};

export enum ADMIN_USER_ACTION_OWNERS {
	CRM = 'CRM'
}

export enum ADMIN_USER_ACTIONS {
	DEACTIVATE_USER_BANK = 'DEACTIVATE_USER_BANK',
	DEACTIVATE_USER_VPA = 'DEACTIVATE_USER_VPA'
}
